import { useContext, useEffect, useReducer } from 'react'
import { Outlet } from 'react-router-dom'
import { opportunityReducer } from './opportunityReducer'
import { opportunityInitialState } from './opportunityInitialState'
import OpportunityContext from './OpportunityContext'
import useOpportunitiesActions from '../../hooks/useOpportunitiesActions'
import { useParams } from 'react-router-dom/dist/umd/react-router-dom.development'
import { OPPORTUNITY_ACTIONS } from './OPPORTUNITY_ACTIONS'

export const useOpportunityContext = () => useContext(OpportunityContext)

export function OpportunityProvider() {
  const { country_id, opportunity_id } = useParams()
  const { getOpportunity } = useOpportunitiesActions()
  const [opportunityState, opportunityDispatch] = useReducer(
    opportunityReducer,
    opportunityInitialState,
  )

  async function fetchCountries(countryId, opportunityId) {
    opportunityDispatch({
      type: OPPORTUNITY_ACTIONS.SET_IS_LOADING,
      payload: {
        isLoading: true,
      },
    })
    const opportunity = await getOpportunity(countryId, opportunityId)
    console.log(countryId, opportunityId)

    opportunityDispatch({
      type: OPPORTUNITY_ACTIONS.SET_OPPORTUNITY,
      payload: {
        opportunity: opportunity,
      },
    })
    opportunityDispatch({
      type: OPPORTUNITY_ACTIONS.SET_IS_LOADING,
      payload: {
        isLoading: false,
      },
    })
  }

  useEffect(() => {
    fetchCountries(country_id, opportunity_id)
    return () => {}
  }, [country_id, opportunity_id])

  return (
    <OpportunityContext.Provider
      value={{ opportunityState, opportunityDispatch }}
    >
      <Outlet />
    </OpportunityContext.Provider>
  )
}
